/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreditCardAuthRequestedRequest
 */
export interface CreditCardAuthRequestedRequest {
  /**
   *
   * @type {string}
   * @memberof CreditCardAuthRequestedRequest
   */
  bookingId: string;
  /**
   *
   * @type {boolean}
   * @memberof CreditCardAuthRequestedRequest
   */
  requested?: boolean;
  /**
   * The client-observed requested timestamp. Required when requested is false.
   * @type {string}
   * @memberof CreditCardAuthRequestedRequest
   */
  expectedRequestedAt?: string | null;
}

/**
 * Check if a given object implements the CreditCardAuthRequestedRequest interface.
 */
export function instanceOfCreditCardAuthRequestedRequest(
  value: object
): value is CreditCardAuthRequestedRequest {
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  return true;
}

export function CreditCardAuthRequestedRequestFromJSON(
  json: any
): CreditCardAuthRequestedRequest {
  return CreditCardAuthRequestedRequestFromJSONTyped(json, false);
}

export function CreditCardAuthRequestedRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreditCardAuthRequestedRequest {
  if (json == null) {
    return json;
  }
  return {
    bookingId: json["booking_id"],
    requested: json["requested"] == null ? undefined : json["requested"],
    expectedRequestedAt:
      json["expected_requested_at"] == null
        ? undefined
        : json["expected_requested_at"],
  };
}

export function CreditCardAuthRequestedRequestToJSON(
  json: any
): CreditCardAuthRequestedRequest {
  return CreditCardAuthRequestedRequestToJSONTyped(json, false);
}

export function CreditCardAuthRequestedRequestToJSONTyped(
  value?: CreditCardAuthRequestedRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    booking_id: value["bookingId"],
    requested: value["requested"],
    expected_requested_at: value["expectedRequestedAt"],
  };
}
